import { Trans } from "@lingui/react";
import { memo, type RefObject } from "react";
import { useSalesPersons } from "../../context/DealerDataProviderContext.tsx";
import { TabId } from "../../utils/tabs.ts";
import "./sections.css";
import EmployeeCard from "../Components/Cards/EmployeeCard.tsx";
import { ScrollContainer } from "../Components/ScrollContainer.tsx";

export const Employees = memo(({ ref }: { ref: RefObject<HTMLDivElement | null> }) => {
  const salesPersons = useSalesPersons();

  return (
    <section id={TabId.Employees} className="section w-full" ref={ref}>
      <h3 className="mb-16">
        <Trans id="dealerBrandingLayout.employees.title" message="Employees" />
      </h3>
      <ScrollContainer className="flex gap-x-16 overflow-x-scroll overflow-y-hidden p-2">
        {salesPersons.map((employee) => (
          <EmployeeCard salesPerson={employee} key={employee.name} />
        ))}
      </ScrollContainer>
    </section>
  );
});
